import type { IconDefinition } from '../index.tsx';

export const iconLock: IconDefinition = {
  prefix: 'fas',
  iconName: 'iconLock',
  icon: [
    16,
    16,
    [],
    '',
    'M4 6V4C4 1.79086 5.79086 0 8 0C10.2091 0 12 1.79086 12 4V6H14V16H2V6H4ZM6 4C6 2.89543 6.89543 2 8 2C9.10457 2 10 2.89543 10 4V6H6V4ZM7 13V9H9V13H7Z',
  ],
  fillRule: 'evenodd',
  clipRule: 'evenodd',
};
